export const RESET_COLOR = '\x1b[0m';
export const RED_COLOR = '\x1b[31m';
export const GREEN_COLOR = '\x1b[32m';
export const BLUE_COLOR = '\x1b[34m';

export const ANSI_COLORS = [RESET_COLOR, RED_COLOR, GREEN_COLOR, BLUE_COLOR];
